import { useState } from "react";
import { BookOpen, Download, Loader2 } from "lucide-react";
import { API_BASE } from "../lib/api";
import { toast } from "sonner";

export default function Manuale() {
    const [loading, setLoading] = useState(false);

    async function download() {
        setLoading(true);
        try {
            const r = await fetch(`${API_BASE}/reports/manuale`);
            if (!r.ok) throw new Error();
            const blob = await r.blob();
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = "manuale_haccp.pdf";
            link.rel = "noopener";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(() => URL.revokeObjectURL(blobUrl), 1500);
            toast.success("Manuale scaricato");
        } catch {
            toast.error("Errore download");
        } finally {
            setLoading(false);
        }
    }

    const sections = [
        { n: "1", t: "Scopo e campo di applicazione" },
        { n: "2", t: "Riferimenti normativi (Reg. CE 852/2004 e correlati)" },
        { n: "3", t: "Organigramma e responsabilità" },
        { n: "4", t: "Descrizione dell'attività di vendita ortofrutticola" },
        { n: "5", t: "Diagramma di flusso del processo" },
        { n: "6", t: "Punti Critici di Controllo (CCP/CP)" },
        { n: "7", t: "Buone Prassi Igieniche (GHP)" },
        { n: "8", t: "Formazione del personale" },
        { n: "9", t: "Tracciabilità e gestione fornitori" },
        { n: "10", t: "Gestione non conformità" },
        { n: "11", t: "Modulistica e registrazioni" },
    ];

    return (
        <div className="space-y-6 pb-6" data-testid="manuale-page">
            <section className="card-soft p-6 bg-gradient-to-br from-[#F0F4F1] to-[#FFFCF6]">
                <div className="flex items-start gap-4 flex-wrap">
                    <div className="w-14 h-14 rounded-2xl bg-forest text-white grid place-items-center">
                        <BookOpen size={24} />
                    </div>
                    <div className="flex-1 min-w-[200px]">
                        <h2 className="font-display text-2xl font-semibold text-forest-dark">
                            Manuale di Autocontrollo HACCP
                        </h2>
                        <p className="text-sm text-stone-600 mt-1">
                            Documento personalizzato per la tua attività di vendita di frutta e verdura, pronto da
                            stampare e conservare in negozio per le ispezioni ASL.
                        </p>
                    </div>
                </div>
                <button
                    onClick={download}
                    disabled={loading}
                    className="btn-primary mt-5 inline-flex items-center gap-2"
                    data-testid="btn-download-manuale"
                >
                    {loading ? <Loader2 size={16} className="animate-spin" /> : <Download size={16} />}
                    Scarica manuale PDF
                </button>
            </section>

            <section className="card-soft p-6" data-testid="manuale-toc">
                <h3 className="font-display text-lg font-semibold text-forest-dark mb-4">Indice dei contenuti</h3>
                <ol className="space-y-2 stagger">
                    {sections.map((s) => (
                        <li key={s.n} className="flex items-start gap-3 py-2 border-b border-soft last:border-0">
                            <span className="w-8 h-8 rounded-lg bg-forest-50 text-forest font-display font-bold grid place-items-center text-sm shrink-0">
                                {s.n}
                            </span>
                            <span className="text-sm text-stone-700 leading-relaxed pt-1">{s.t}</span>
                        </li>
                    ))}
                </ol>
            </section>

            <section className="card-soft p-5 bg-[#FFF8EE] border-[#E9A846]/30">
                <p className="text-sm text-stone-700">
                    <strong className="text-forest-dark">Suggerimento:</strong> compila i dati del negozio nella
                    sezione <em>Impostazioni</em> prima di scaricare il manuale, così verrà personalizzato con la
                    tua P.IVA, codice fiscale e responsabile HACCP.
                </p>
            </section>
        </div>
    );
}
